<template>
  <div id="app" class="pan">
    <login-header></login-header>
    <login-form></login-form>
  </div>
</template>

<script>
  import LoginHeader from './components/Header'
  import LoginForm from './components/Form'

  export default {
    name: 'App',
    components: {
      LoginHeader,
      LoginForm
    }
  }
</script>

<style lang="stylus" scoped>
  .pan
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100%
    min-width: 1000px
    z-index: -10
    zoom: 1
    background-image: url(images/bg_cover.png)
    background-color: #fff
    background-repeat: no-repeat
    background-size: cover
    background-position: center 0
</style>



// WEBPACK FOOTER //
// src/pages/index/App.vue